import type { TagVariantType } from "common/components/ui/Tag";

import type { LabelColor } from "./types";

export const LABEL_COLORS: Record<
  LabelColor,
  {
    name: string;
    bgClassName: string;
    textClassName: string;
    tagVariant: TagVariantType;
  }
> = {
  quaternary: {
    name: "Lime",
    bgClassName: "bg-lime-200",
    textClassName: "text-lime-700",
    tagVariant: "lime",
  },
  secondary: {
    name: "Purple",
    bgClassName: "bg-purple-200",
    textClassName: "text-purple-700",
    tagVariant: "secondary",
  },
  danger: {
    name: "Red",
    bgClassName: "bg-red-200",
    textClassName: "text-red-600",
    tagVariant: "danger",
  },
  yellow: {
    name: "Yellow",
    bgClassName: "bg-yellow-200",
    textClassName: "text-yellow-700",
    tagVariant: "yellow",
  },
  info: {
    name: "Blue",
    bgClassName: "bg-blue-200",
    textClassName: "text-blue-700",
    tagVariant: "info",
  },
  success: {
    name: "Green",
    bgClassName: "bg-green-200",
    textClassName: "text-green-700",
    tagVariant: "success",
  },
  orange: {
    name: "Orange",
    bgClassName: "bg-orange-200",
    textClassName: "text-orange-700",
    tagVariant: "orange",
  },
  magenta: {
    name: "Magenta",
    bgClassName: "bg-magenta-200",
    textClassName: "text-magenta-700",
    tagVariant: "magenta",
  },
} as const;
